<script setup lang="ts">
    import UserAvatar from '../../UserAvatar.vue';

    defineProps<{
        label: string;
        color?: 'blueberry' | 'acai' | 'plum' | 'raspberry' | 'avocado';
    }>();
</script>
<template>
    <div class="flex gap-2 items-center">
        <p class="text-body flex items-center">
            <UserAvatar :label="label" :color="color" class="mr-3" />
            {{ label }}
        </p>
    </div>
</template>
